import UserAgent from '../UserAgent/UserAgent'

import touch from '../touch/touch'

/** A HTML tag-et dekorálja különböző classokkal, hogy miket tud az adott eszköz és browser. */
export default function setDeviceClasses (): void {
  const html = document.querySelector('html') as HTMLElement

  const ua = UserAgent.getInstance()

  // Ha van touch support, akkor jelöljük a <html> tag-en, hogy a játékokban például a :hover -t ki tudjuk ütni.
  // html:global(.touch) { }
  if (touch.isTouchSupported()) {
    html.classList.add('touch')
  }

  // Ha handheld, akkor a <html> kap egy handheld class-t amire majd tudunk hivatkozni a css-ben.
  // html:global(.handheld) { }
  if (ua.isHandheld) {
    html.classList.add('handheld')
  }
  else {
    html.classList.add('desktop')
  }

  if (ua.isIOS) {
    html.classList.add('ios')
  }

  if (ua.isApple) {
    html.classList.add('apple')
  }

  // A WEBP support a pug/index.pug-ban található.
}
